'use client';

import React from 'react';

import { ComponentContainer, ComponentWrapper } from '../shared/styles';

import { OneColumnVariation } from './OneColumnVariation';
import { TwoColumnsVariation } from './TwoColumnsVariation';
import { BulkTextProps } from './types';

// TextImageText in Strapi
export const BulkText: React.FC<BulkTextProps> = ({ variation, ...props }) => {
  return (
    <ComponentWrapper>
      <ComponentContainer>
        {variation === 'oneColumn' ? (
          <OneColumnVariation {...props} />
        ) : (
          <TwoColumnsVariation {...props} />
        )}
      </ComponentContainer>
    </ComponentWrapper>
  );
};
